<template>
    <div class="lunBoTu">
        <el-carousel :interval="500000" arrow="never">
            <el-row class="tac">
                <el-col :span="12">
                    <el-menu default-active="2" class="el-menu-vertical-demo" :unique-opened="true">
                        <el-submenu index="1">
                            <template slot="title">
                                <img src="../image/menu.png" alt="" class="imgname">
                            </template>
                            <el-menu-item-group>
                                <template v-for="(menu, index) in navList">
                                    <el-menu-item :index="`1-${index + 1}`" v-if="menu.children.length == 0"
                                        :key="menu.index">
                                        <router-link :to="menu.route" class="linkclass">
                                            {{ menu.name }}
                                        </router-link>
                                    </el-menu-item>
                                    <el-submenu :index="`1-${index + 1}`" v-if="menu.children.length !== 0" :key="menu.index">
                                        <template slot="title">{{ menu.name }}</template>
                                        <el-menu-item v-for="(subMenu, subIndex) in menu.children"
                                            :index="`1-${index + 1}-${subIndex + 1}`" :key="subMenu.index">
                                            <router-link :to="subMenu.route" class="linkclass">{{ subMenu.name
                                            }}</router-link>
                                        </el-menu-item>
                                    </el-submenu>
                                </template>
                            </el-menu-item-group>
                        </el-submenu>
                    </el-menu>
                </el-col>
            </el-row>
            <el-carousel-item>
                <video src="@/image/video.mp4" controls autoplay muted></video>
            </el-carousel-item>
            <el-carousel-item v-for="(item, index) in images" :key="index">
                <img :src="item.url" :alt="item.alt" v-resize-scale="{ hoverClassName: 'is-hover' }">
                <div class="caption">
                    <p class="caption-1">{{ item.caption }}</p>
                    <p class="caption-2">{{ item.caption1 }}</p>
                    <p class="caption-3">{{ item.caption2 }}</p>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
  
<script>
import { api_category } from "@/APi/api";
export default {
    data() {
        return {
            navList:[],
            images: [
                {
                    url: require('../image/img1.png'),
                    alt: 'Image 1',
                    caption: '四川智如客科技 >',
                    caption1: ' 四川智如客科技有限公司成立于2018年，位于成都市天府新区，由多位行业大咖共同创建，是一家专注于互联网智慧型软件开发及应用的高新技术企业、全国科技型企业 ',
                    caption2: ' 四川智如客科技有限公司致力于为客户提供由传统互联网到移动互联网智能一体化的解决方案、技术支持 '
                },
            ]
        };
    },
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
         // 获取栏目列表
         getCategory() {
            api_category().then((res) => {
                this.navList = res.data;
                // console.log(this.navList)
            });
        },
    },
    created() {
        this.getCategory();
    },
    directives: {
        resizeScale: {
            inserted(el, binding) {
                const { hoverClassName } = binding.value;
                el.addEventListener('mouseenter', function () {
                    el.classList.add(hoverClassName);
                });
                el.addEventListener('mouseleave', function () {
                    el.classList.remove(hoverClassName);
                });
            }
        }
    }
};
</script>
  
<style lang="scss">
/* element-ui 组件样式 */

/* 轮播图组件样式 */
.el-carousel__item h3 {
    color: #475669;
    opacity: 1;
    line-height: 100%;
    margin: 0;
}

.lunBoTu .el-carousel__container {
    height: 100vh;
}

.lunBoTu .el-carousel__item img.is-hover {
    transform: scale(1.2);
}

/* 导航菜单组件 */
.el-col-12 {
    width: 100%;
}

.el-menu {
    background-color: transparent;
    display: flex;
    flex-direction: column;
}

.el-submenu .el-menu-item {
    color: white;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.el-submenu__title {
    color: white;
    background-color: transparent !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}

.el-icon-arrow-down:before {
    color: white;
}

.linkclass {
    text-decoration: none;
    color: white;
}

.router-link-active {
    text-decoration: none !important;
    color: inherit;
    /* 继承父元素的颜色 */
}

/* 自定义样式 */
* {
    padding: 0;
    margin: 0;
}

.lunBoTu {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;

    img {
        width: 100%;
        height: 100%;
        transition: transform 5s ease;
        z-index: 1;
    }

    video {
        width: 100%;
        height: 100%;
        object-fit: fill;
    }

    &.is-hover img {
        transform: scale(1.2);
    }

    .caption {
        width: 30rem;
        height: 20rem;
        position: absolute;
        top: 30%;
        left: 5%;
        right: 0;
        z-index: 2;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: space-around;
        flex-wrap: wrap;
        align-items: flex-start;
        color: white;
        font-weight: 600;

        .caption-1 {
            font-size: 2rem;
            cursor: pointer;
        }

        .caption-2 {
            font-size: 1rem;
            cursor: pointer;
        }

        .caption-3 {
            font-size: 1rem;
            cursor: pointer;
        }
    }

    .tac {
        z-index: 3;
        position: relative;
        width: 13%;
        margin-left: 87%;
        height: 100%;
        background: linear-gradient(90deg, rgba(56, 98, 154, 0) 0%, rgba(58, 100, 156, 0.86) 100%);

        .imgname {
            width: 1.38rem;
            height: 1.38rem;
            margin-left: 11%;
        }
    }
}

.caption p {
    // font-size: 2rem;
    transition: color 1s ease;
}

.caption p:hover {
    color: blue; // 这里的颜色可以根据需要自行调整
}

// 移动端
@media screen and (max-width:900px) {

    // 移动端样式
    .el-carousel__item h3 {
        color: #475669;
        opacity: 1;
        line-height: 100%;
        margin: 0;
    }

    .lunBoTu .el-carousel__container {
        height: 100vh;
    }

    .lunBoTu .el-carousel__item img.is-hover {
        transform: scale(1.2);
    }

    /* 导航菜单组件 */
    .el-col-12 {
        width: 100%;
    }

    .el-menu {
        background-color: transparent;
        display: flex;
        flex-direction: column;
    }

    .el-submenu .el-menu-item {
        color: white;
        background-color: transparent;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .el-submenu__title {
        color: white;
        background-color: transparent !important;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }

    .el-icon-arrow-down:before {
        color: white;
    }

    .linkclass {
        text-decoration: none;
        color: white;
    }

    .router-link-active {
        text-decoration: none !important;
        color: inherit;
        /* 继承父元素的颜色 */
    }

    /* 自定义样式 */
    * {
        padding: 0;
        margin: 0;
    }

    .lunBoTu {
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
            transition: transform 5s ease;
            z-index: 1;
        }

        video {
            width: 100%;
            height: 100%;
            object-fit: fill;
        }

        &.is-hover img {
            transform: scale(1.2);
        }

        .caption {
            width: 20rem;
            height: 20rem;
            position: absolute;
            top: 30%;
            left: 5%;
            right: 0;
            z-index: 2;
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-content: center;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: flex-start;
            color: white;
            font-weight: 600;

            .caption-1 {
                font-size: 2rem;
                cursor: pointer;
            }

            .caption-2 {
                font-size: 1rem;
                cursor: pointer;
            }

            .caption-3 {
                font-size: 1rem;
                cursor: pointer;
            }
        }

        .tac {
            z-index: 3;
            position: relative;
            width: 35%;
            margin-left: 65%;
            height: 100%;
            background: linear-gradient(90deg, rgba(56, 98, 154, 0) 0%, rgba(58, 100, 156, 0.86) 100%);

            .imgname {
                width: 1.38rem;
                height: 1.38rem;
                margin-left: 11%;
            }
        }
    }

    .caption p {
        // font-size: 2rem;
        transition: color 1s ease;
    }

    .caption p:hover {
        color: blue; // 这里的颜色可以根据需要自行调整
    }
}</style>